import { createRouter, createWebHistory, RouteRecordRaw,createWebHashHistory } from 'vue-router'
// import Home from '../views/Home.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/index'
  },
  {
    path: '/',
    name: '',
    component: ()=>import('@/components/Index.vue'),
    children:[
      {
        path: '/index',
        name: 'index',
        component: ()=>import('@/components/pc/Home.vue'),
        meta:{
          title:'易鲸云 - 帮助中心'
        }
      },
      {
        path: '/search',
        name: 'search',
        component: ()=>import('@/components/pc/SearchList.vue'),
        meta:{
          title:'易鲸云 - 帮助中心'
        }
      },
      {
        path: '/article/:id?',
        name: 'article',
        component: ()=>import('@/components/pc/isArticle.vue'),
        meta:{
          title:'易鲸云 - 帮助中心'
        }
      },
      // {
      //   path: '/isArticle',
      //   name: 'isArticle',
      //   component: ()=>import('@/components/pc/isArticle.vue'),
      // }
    ]
  },
  {
    path: '/updateArticle',
    name: 'updateArticle',
    component: ()=>import('@/components/pc/updateArticle.vue'),
    meta:{
      title:'易鲸云 - 帮助中心'
    }
  },
  {
    path: '/mhome',
    name: 'mhome',
    meta: {
        title: "易鲸云 - 帮助中心"
    },
    component: ()=>import('@/components/mobile/home.vue'),
  },
  {
    path: '/mNav',
    name: 'mNav',
    meta: {
        title: "易鲸云 - 帮助中心"
    },
    component: ()=>import('@/components/mobile/navigation.vue'),
  },
  {
    path: '/marticle/:id?',
    name: 'marticle',
    meta: {
        title: "易鲸云 - 帮助中心"
    },
    component: ()=>import('@/components/mobile/article.vue'),
  },
  {
    path: '/openAdvicse',
    name: 'openAdvicse',
    meta: {
        title: "易鲸云 - 帮助中心"
    },
    component: ()=>import('@/components/mobile/openAdvise.vue'),
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = createRouter({
  // process.env.BASE_URL
  // history: createWebHistory(),
  history:createWebHashHistory(),
  routes
})

export default router
